export function usePlausible(){
    try {
        window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }
        return window.plausible;
    }   catch (e) {
        return null;
    }
}